import React from "react";
import ErrorPage from "../../../components/shared/ErrorPage";

const SearchNoResult = () => (
  <ErrorPage
    imageUrl="/assets/svg/empty-state.svg"
    errorPageDescription="Start your search for companies, experts, topics and videos"
    class="search headWhite"
  />
);

export default SearchNoResult;
